import { render, staticRenderFns } from "./ProjectLayoutAsideChild.vue?vue&type=template&id=782b3d86&scoped=true&"
import script from "./ProjectLayoutAsideChild.vue?vue&type=script&lang=ts&"
export * from "./ProjectLayoutAsideChild.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectLayoutAsideChild.vue?vue&type=style&index=0&id=782b3d86&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "782b3d86",
  null
  
)

export default component.exports